import { AdminStatsAndReportsModel } from '../shared/models/admin-stats-and-reports-model';
import { StatsAndReportsService } from '../shared/services/stats-and-reports.service';
import { Component, OnInit } from '@angular/core';
import { UserService } from '@admin/core/user.service';
import { FeatureEnum } from '@admin/shared/models/feature-enum';

@Component({
  selector: 'hr-stats-and-reports-list',
  templateUrl: './stats-and-reports-list.component.html',
  styleUrls: ['./stats-and-reports-list.component.less'],
  standalone: false,
})
export class StatsAndReportsListComponent implements OnInit {
  public adminStatsAndReports: AdminStatsAndReportsModel;

  hasMonthlyPlanEnterPermission: boolean;
  hasMonthlyPlanReportViewPermission: boolean;

  constructor(
    private statsAndReportsService: StatsAndReportsService,
    private userService: UserService
  ) {
    this.adminStatsAndReports = new AdminStatsAndReportsModel();
    this.hasMonthlyPlanEnterPermission = false;
    this.hasMonthlyPlanReportViewPermission = false;
  }

  ngOnInit() {
    this.hasMonthlyPlanEnterPermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.EnterSalesMonthlyPlan
      );
    this.hasMonthlyPlanReportViewPermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.ViewSalesMonthlyPlanReport
      );

    this.statsAndReportsService.getStats().subscribe((s) => {
      this.adminStatsAndReports = s;
    });
  }
}
